module.exports = __webpack_public_path__ + "img/trailer-color.cf6dd884.jpg";